import { ProductInterface } from "../../../interfaces/productInterface";
import { useProductQuery } from "../queries/useProductsQuery";

type Response = {
  data?: ProductInterface;
  isLoading: boolean;
};

export type UseProductByIdParams = {
  productId?: string;
};

export const useProduct = (opt: UseProductByIdParams): Response => {
  const { productId } = opt;
  const { data, isLoading } = useProductQuery(productId);
  return {
    data: data?.data,
    isLoading,
  };
};
